import { EnvironmentInterface } from './environment.interface';

// uses dev-apigee and Entra non-prod app registration
export const environment: EnvironmentInterface = {
  backend_host: 'https://soundradar-entwicklung.gema.de/api/nadapp/backend',
  msalConfig: {
    auth: {
      clientId: 'f118024d-67d0-41a8-b6a7-f809bc05120b',
      authority: 'https://login.microsoftonline.com/a0b0066e-b01b-4359-a94b-ec138b733044',
      redirectUri: globalThis.location.origin + '/auth',
      postLogoutRedirectUri: globalThis.location.origin + '/logout',
    },
    cache: {
      cacheLocation: 'sessionStorage',
    },
  },
  loginRequest: {
    scopes: ['openid', 'profile', 'f118024d-67d0-41a8-b6a7-f809bc05120b/.default'],
  },
  allowed_max_distance_m: 50,
  allow_start_without_gps: true,
  session_timeout_minutes: 30,
  stage: 'dev',
};
